<script>
import BaseApp from '../../BaseApp';

export default {
  name: "NotFound",
  mixins: [BaseApp],
  beforeRouteEnter(to) {
    if (to.name === 'not_found') {
      window.location.href = '/shop/cart/';
    }
  },
}
</script>